import { render, staticRenderFns } from "./ChallengeSidenav.vue?vue&type=template&id=98f697d6"
import script from "./ChallengeSidenav.vue?vue&type=script&lang=js"
export * from "./ChallengeSidenav.vue?vue&type=script&lang=js"
import style0 from "./ChallengeSidenav.vue?vue&type=style&index=0&id=98f697d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports